import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ie-lanzhou",
  "use": "icon-ie-lanzhou-usage",
  "viewBox": "0 0 1239 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1239 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ie-lanzhou\">\n    <path d=\"M769.913263 323.503158v694.433684h459.37179L769.913263 323.503158zM659.941053 0C281.896421 87.336421 0 425.269895 0 829.197474A852.399158 852.399158 0 0 0 21.301895 1017.936842h638.625684V0z\" fill=\"#396BFB\" p-id=\"1990\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol